import { render, staticRenderFns } from "./DataBlock.vue?vue&type=template&id=d3ff2e6a&scoped=true"
import script from "./DataBlock.vue?vue&type=script&lang=ts"
export * from "./DataBlock.vue?vue&type=script&lang=ts"
import style0 from "./DataBlock.vue?vue&type=style&index=0&id=d3ff2e6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3ff2e6a",
  null
  
)

export default component.exports